export const EVENT_SET_EVENTS = "events/set-events";
export const EVENT_ADD_EVENT = "events/add-event";
export const EVENT_REMOVE_EVENT = "events/remove-event";
export const EVENT_TOGGLE_EVENT = "events/toggle-event";
export const EVENT_DISABLE_CATEGORY = "events/disable-category";
export const EVENT_ENABLE_CATEGORY = "events/enable-category";
export const EVENT_GET_RANDOM_EVENT = "events/get-random-event";
export const EVENT_DISABLE_INELIGIBLE_EVENTS =
  "events/disable-ineligible-events";
